var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33333C2 4.38781 4.50385 2 7.5925 2C10.6811 2 13.185 4.38781 13.185 7.33333C13.185 10.366 10.3318 12.5993 8.3694 13.6317C7.88321 13.8875 7.30179 13.8875 6.81559 13.6317C4.85316 12.5993 2 10.366 2 7.33333ZM7.5925 10C8.99643 10 10.1345 8.88071 10.1345 7.5C10.1345 6.11929 8.99643 5 7.5925 5C6.18856 5 5.05045 6.11929 5.05045 7.5C5.05045 8.88071 6.18856 10 7.5925 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39432 13.0865L2.36039 19.6959C2.3031 20.0621 2.35023 20.4175 2.4783 20.7351L18.9481 9.03693C18.8215 9.01267 18.6911 9 18.5579 9H14.4871C14.1434 10.268 13.4414 11.352 12.6558 12.2261C11.5461 13.4605 10.1827 14.3788 9.08877 14.9543C8.1531 15.4466 7.0318 15.4466 6.09612 14.9543C5.27371 14.5217 4.29899 13.8953 3.39432 13.0865Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37045 22C4.0747 22 3.79545 21.9385 3.54407 21.8284L12.1681 15.703L20.7923 21.8285C20.5409 21.9385 20.2617 22 19.9659 22H4.37045Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9759 19.6959C22.0332 20.0621 21.9861 20.4175 21.858 20.7351L13.4707 14.7778L20.2825 9.93951C20.4255 10.1641 20.5248 10.4198 20.568 10.6959L21.9759 19.6959Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderMap);
export default __webpack_public_path__ + "static/media/placeholder-map.e2fa39f00f3f788c75e12160ad5b92e5.svg";
export { ForwardRef as ReactComponent };